import { WebPlugin } from '@capacitor/core';
import { BiometryType, AuthenticationStrength } from './definitions';
export class NativeBiometricWeb extends WebPlugin {
    constructor() {
        super();
    }
    isAvailable() {
        // Web platform: biometrics not available, but return structured response
        return Promise.resolve({
            isAvailable: false,
            authenticationStrength: AuthenticationStrength.NONE,
            biometryType: BiometryType.NONE,
            deviceIsSecure: false,
            strongBiometryIsAvailable: false,
        });
    }
    async addListener(_eventName, _listener) {
        // Web platform: no-op, but return a valid handle
        return {
            remove: async () => {
                // Nothing to remove on web
            },
        };
    }
    verifyIdentity(_options) {
        console.log('verifyIdentity', _options);
        throw new Error('Biometric authentication is not available on web platform.');
    }
    getCredentials(_options) {
        console.log('getCredentials', _options);
        throw new Error('Credential storage is not available on web platform.');
    }
    setCredentials(_options) {
        console.log('setCredentials', _options);
        throw new Error('Credential storage is not available on web platform.');
    }
    deleteCredentials(_options) {
        console.log('deleteCredentials', _options);
        throw new Error('Credential storage is not available on web platform.');
    }
    isCredentialsSaved(_options) {
        console.log('isCredentialsSaved', _options);
        // Return false on web - no credentials can be saved
        return Promise.resolve({ isSaved: false });
    }
    async getPluginVersion() {
        return { version: 'web' };
    }
}
//# sourceMappingURL=web.js.map